import React from 'react';
import BackButton from '../components/BackButton'

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy container mt-2">
        <BackButton title="Privacy Policy" />
      <p><strong>Effective Date: 17 Jan 2024</strong></p>

      <p>
        Thank you for choosing Avatalk AI ("we," "us," or "our"). This Privacy Policy is designed to help you understand how we collect, use, disclose, and safeguard your personal information when you use our mobile application (the "App").
      </p>
      <p>
        By downloading, installing, and using the Avatalk AI App, you agree to the terms outlined in this Privacy Policy. If you do not agree with these terms, please refrain from using the App.
      </p>

      <h2>1. Information We Collect</h2>
      <h3>1.1 User-Provided Information</h3>
      <p>
        To operate the Avatalk AI App, we may request certain permissions and collect the following information:
      </p>
      <ul>
        <li><strong>Prompt or Image:</strong> The App uses a public API to create avatars based on the prompts or images provided by users.</li>
      </ul>

      <h3>1.2 Automatically Collected Information</h3>
      <ul>
        <li><strong>Usage Information:</strong> We collect information about your usage of the App, such as the features you use, the duration of usage, and interactions with the avatars created.</li>
        <li><strong>Device Information:</strong> We may collect information about the device you use to access the App, including device type, operating system, and unique device identifiers.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We use the information collected to:</p>
      <ul>
        <li><strong>Create Avatars:</strong> The primary purpose of collecting prompts or images is to generate avatars using the public API integrated into the App.</li>
        <li><strong>Improve User Experience:</strong> Analyze usage patterns to enhance and optimize the App's features and performance.</li>
        <li><strong>Provide Customer Support:</strong> Address user inquiries, troubleshoot problems, and provide assistance.</li>
      </ul>

      <h2>3. Sharing of Information</h2>
      <p>
        We do not sell, trade, or otherwise transfer your personal information to third parties. However, we may share information in the following circumstances:
      </p>
      <ul>
        <li><strong>With Your Consent:</strong> We may share information with third parties if you explicitly consent to such sharing.</li>
        <li><strong>Compliance with Laws:</strong> We may disclose information to comply with legal obligations or respond to governmental requests.</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We take reasonable measures to protect your information from unauthorized access, disclosure, alteration, and destruction. However, no method of transmission over the internet or electronic storage is entirely secure, and we cannot guarantee absolute security.
      </p>

      <h2>5. Changes to this Privacy Policy</h2>
      <p>
        We reserve the right to update this Privacy Policy periodically. Any changes will be posted on this page, and the effective date will be updated accordingly. It is your responsibility to review this Privacy Policy periodically for changes.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
